export const BUTTON_LABELS = {
  copyIssueLink: 'Copy permalink',
  deleteIssue: 'Delete issue',
  issueActions: 'Issue actions',
  transferIssue: 'Transfer issue',
  tryAgain: 'Try again',
  updateComment: 'Update comment',
  new: 'New issue',
  cancel: 'Cancel',
  submitIssueTitleEdit: 'Save',
  closePanel: 'Close panel',
  changeIssueType: 'Change issue type',
  changeType: 'Change type',
  editTitle: 'Edit',
}
